var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      directives: [
        {
          name: "analytics",
          rawName: "v-analytics",
          value: { label: "header_search" },
          expression: "{label:'header_search'}",
        },
      ],
      on: {
        click: function ($event) {
          return _vm.$emit("click")
        },
      },
    },
    [_vm._v("検索")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }